module.exports = __webpack_public_path__ + "static/media/Carpenter3.9c365f09.png";